<template>
   <footer class="home_footer">
      <ul class="flx">
        <router-link :to="{ path: '/'}" tag="li" :class="{'active' : $route.path == '/' }" replace @click.native="footerTab('home')">
         
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g fill="#000" fill-rule="nonzero" opacity=".235">
            <path
              d="M14.48 20.819H9.897v-6.685h4.583v6.685zm5.731.035h-4.584v-7.293a.573.573 0 0 0-.573-.573h-5.73a.573.573 0 0 0-.573.573v7.293H4.167V10.187l8.056-6.862 7.988 6.797v10.732z"
            />
            </g>
          </svg>
          <h5>{{$t('mall')}}</h5>
        </router-link>
           <router-link :to="{ path: '/shopping-game'}" tag="li" :class="{'active' : $route.path == '/shopping-game' }" replace @click.native="footerTab('shoppinggame')">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
                <path
                  fill="#444"
                  fill-rule="nonzero"
                  d="M14.65 9.981l-.19-3.956h-1.888v-.989c0-2.768-2.077-4.944-4.722-4.944-2.644 0-4.721 2.176-4.721 4.944v.99H1.24L.39 19.77c0 1.088.85 2.077 1.889 2.077h4.627V9.98h7.743zM5.961 6.025v-.989c0-1.087.85-1.977 1.888-1.977 1.04 0 1.89.89 1.89 1.977v.99H5.961zm14.988 5.11c1.692.536 2.542 2.418 3.343 5.958.8 3.545.653 6.104-.291 6.58-.944.477-2.01-.616-3.026-1.966-.887-1.097-1.239-1.125-4.627-1.125-3.392 0-3.803.068-4.627 1.125-1.016 1.35-2.081 2.443-3.025 1.966-.945-.476-1.092-3.035-.291-6.58.8-3.54 1.647-5.426 3.343-5.959 1.696-.537 2.228.477 4.6.477 2.372 0 2.905-1.01 4.6-.477zm-1.06 4.285c.392 0 .709-.332.709-.742s-.317-.741-.709-.741c-.39 0-.708.332-.708.741 0 .41.317.742.708.742zm0 3.956c.392 0 .709-.333.709-.742 0-.41-.317-.742-.709-.742-.39 0-.708.332-.708.742s.317.742.708.742zm-1.888-1.978c.39 0 .708-.332.708-.742s-.317-.742-.708-.742c-.391 0-.708.332-.708.742s.317.742.708.742zm-6.61.989c.912 0 1.652-.775 1.652-1.73 0-.957-.74-1.732-1.652-1.732-.913 0-1.653.775-1.653 1.731 0 .956.74 1.73 1.653 1.73zm10.387-.99c.391 0 .708-.331.708-.74 0-.41-.317-.743-.708-.743-.391 0-.708.332-.708.742s.317.742.708.742z"
                />
              </svg>
            <h5>{{$t('shoppingGame')}}</h5>
          </router-link>
        <router-link :to="{ path: '/live-show'}" tag="li" :class="{'active' : $route.path == '/live-show' }" replace @click.native="footerTab('tvshop')">
        <span class="badge1">
          <span class="badge_text" v-if="dataLiveShow">LIVE</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 26 23">
            <g fill="#000" fill-rule="nonzero" opacity=".219">
              <path
                d="M24.375 0H1.625C.73 0 0 .738 0 1.643V18.07c0 .906.73 1.643 1.625 1.643h8.601l-1.862 1.883a.826.826 0 0 0-.176.895c.124.308.421.508.75.508h8.124c.329 0 .626-.2.751-.508a.826.826 0 0 0-.175-.895l-1.864-1.883h8.601c.895 0 1.625-.737 1.625-1.643V1.643C26 .738 25.27 0 24.375 0zM10.899 21.357l1.625-1.643h.952l1.625 1.643H10.9zm13.476-3.286H1.625V16.43h22.75v1.642zm0-3.285H1.625V1.643h22.75v13.143z"
              />
              <path
                d="M17.875 6.571h-1.123l-1.4-2.832a.81.81 0 0 0-1.091-.366.825.825 0 0 0-.362 1.102l1.036 2.096h-3.87L12.1 4.475a.826.826 0 0 0-.364-1.102.809.809 0 0 0-1.088.366L9.248 6.571H8.125a.817.817 0 0 0-.813.822c0 .453.364.821.813.821h.123l.7 4.242a.817.817 0 0 0 .802.687h6.5c.398 0 .736-.29.801-.687l.7-4.242h.124a.817.817 0 0 0 .813-.821.817.817 0 0 0-.813-.822zM15.563 11.5h-5.126l-.54-3.286h6.207l-.541 3.286z"
              />
            </g>
          </svg> 
        </span>
        <h5>{{$t('tvShop')}}</h5>
        </router-link>

        <router-link :to="{ path: '/order-history'}" tag="li" :class="{'active' : $route.path == '/order-history' }" replace @click.native="footerTab('orderhistory')">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="26" viewBox="0 0 21 26">
            <g fill="#000" fill-rule="nonzero" opacity=".235">
              <path
                d="M20.986 21.44L19.804 6.81c-.074-.943-.886-1.681-1.849-1.681H15.62v-.103C15.62 2.255 13.323 0 10.5 0S5.381 2.255 5.381 5.026v.103H3.045c-.963 0-1.775.738-1.848 1.679L.014 21.443a4.2 4.2 0 0 0 1.135 3.2A4.363 4.363 0 0 0 4.313 26h12.374c1.197 0 2.35-.495 3.164-1.357a4.2 4.2 0 0 0 1.135-3.202zM6.932 5.027c0-1.932 1.6-3.503 3.568-3.503 1.967 0 3.568 1.571 3.568 3.503v.103H6.932v-.103zm11.78 18.582a2.756 2.756 0 0 1-2.025.87H4.313a2.756 2.756 0 0 1-2.025-.87 2.652 2.652 0 0 1-.728-2.047L2.743 6.926a.302.302 0 0 1 .302-.274h2.336v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h7.136v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h2.336c.157 0 .29.12.302.276L19.44 21.56c.06.761-.199 1.49-.727 2.05z"
              />
              <path
                d="M13.994 12.913a.786.786 0 0 0-1.096 0l-3.464 3.4-1.331-1.307a.786.786 0 0 0-1.097 0 .752.752 0 0 0 0 1.076l1.88 1.846a.78.78 0 0 0 .548.223.78.78 0 0 0 .549-.223l4.011-3.938a.752.752 0 0 0 0-1.077z"
              />
            </g>
          </svg>

          <h5>{{$t('orderHistory')}}</h5>
        </router-link>
        <router-link :to="{ path: '/category-listing'}" tag="li" :class="{'active' : $route.path == '/category-listing' }" replace @click.native="footerTab('category')">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
            <g fill="#000" fill-rule="nonzero" opacity=".205">
              <path
                d="M2.415 11.538h6.7a2.397 2.397 0 0 0 2.394-2.394v-6.7A2.397 2.397 0 0 0 9.114.05H2.415A2.397 2.397 0 0 0 .021 2.445v6.699a2.397 2.397 0 0 0 2.394 2.394zm-.63-9.093a.63.63 0 0 1 .63-.63h6.7a.63.63 0 0 1 .63.63v6.699a.63.63 0 0 1-.63.63h-6.7a.63.63 0 0 1-.63-.63v-6.7z"
              />
              <path
                d="M9.114 11.56H2.415A2.418 2.418 0 0 1 0 9.143v-6.7A2.418 2.418 0 0 1 2.415.03h6.7a2.418 2.418 0 0 1 2.414 2.415v6.699a2.418 2.418 0 0 1-2.415 2.415zM2.415.07A2.377 2.377 0 0 0 .041 2.446v6.699a2.377 2.377 0 0 0 2.374 2.374h6.7a2.377 2.377 0 0 0 2.373-2.374v-6.7A2.377 2.377 0 0 0 9.114.072H2.415zm6.7 9.725h-6.7a.651.651 0 0 1-.65-.651v-6.7c0-.358.291-.65.65-.65h6.7c.358 0 .65.292.65.65v6.7c0 .359-.292.65-.65.65zm-6.7-7.96a.61.61 0 0 0-.61.61v6.699c0 .336.274.61.61.61h6.7a.61.61 0 0 0 .609-.61v-6.7a.61.61 0 0 0-.61-.609H2.415zM22.58.05h-6.7a2.397 2.397 0 0 0-2.394 2.395v6.699a2.397 2.397 0 0 0 2.395 2.394h6.699a2.397 2.397 0 0 0 2.394-2.394v-6.7A2.397 2.397 0 0 0 22.58.05zm.63 9.094a.63.63 0 0 1-.63.63h-6.7a.63.63 0 0 1-.63-.63v-6.7a.63.63 0 0 1 .63-.63h6.7a.63.63 0 0 1 .63.63v6.7z"
              />
              <path
                d="M22.58 11.56h-6.7a2.418 2.418 0 0 1-2.414-2.416v-6.7A2.418 2.418 0 0 1 15.88.03h6.699a2.418 2.418 0 0 1 2.415 2.415v6.699a2.418 2.418 0 0 1-2.415 2.415zM15.88.07a2.377 2.377 0 0 0-2.373 2.375v6.699a2.377 2.377 0 0 0 2.374 2.374h6.699a2.377 2.377 0 0 0 2.374-2.374v-6.7A2.377 2.377 0 0 0 22.58.072h-6.7zm6.7 9.725h-6.7a.651.651 0 0 1-.65-.651v-6.7c0-.358.292-.65.65-.65h6.7c.359 0 .65.292.65.65v6.7c0 .359-.291.65-.65.65zm-6.7-7.96a.61.61 0 0 0-.609.61v6.699c0 .336.274.61.61.61h6.699a.61.61 0 0 0 .61-.61v-6.7a.61.61 0 0 0-.61-.609h-6.7z"
              />
              <g>
                <path
                  d="M2.415 24.945h6.7a2.397 2.397 0 0 0 2.394-2.395v-6.699a2.397 2.397 0 0 0-2.395-2.395H2.415a2.397 2.397 0 0 0-2.394 2.395v6.7a2.397 2.397 0 0 0 2.394 2.394zm-.63-9.094a.63.63 0 0 1 .63-.63h6.7a.63.63 0 0 1 .63.63v6.7a.63.63 0 0 1-.63.63h-6.7a.63.63 0 0 1-.63-.63v-6.7z"
                />
                <path
                  d="M9.114 24.965H2.415A2.418 2.418 0 0 1 0 22.55v-6.699a2.418 2.418 0 0 1 2.415-2.415h6.7a2.418 2.418 0 0 1 2.414 2.415v6.7a2.418 2.418 0 0 1-2.415 2.414zM2.415 13.477a2.377 2.377 0 0 0-2.374 2.374v6.7a2.377 2.377 0 0 0 2.374 2.373h6.7a2.377 2.377 0 0 0 2.373-2.374v-6.699a2.377 2.377 0 0 0-2.374-2.374H2.415zm6.7 9.724h-6.7a.651.651 0 0 1-.65-.65v-6.7c0-.359.291-.65.65-.65h6.7c.358 0 .65.291.65.65v6.7c0 .358-.292.65-.65.65zm-6.7-7.96a.61.61 0 0 0-.61.61v6.7c0 .335.274.609.61.609h6.7a.61.61 0 0 0 .609-.61v-6.699a.61.61 0 0 0-.61-.61H2.415z"
                />
              </g>
              <g>
                <path
                  d="M22.58 13.457h-6.7a2.397 2.397 0 0 0-2.394 2.394v6.7a2.397 2.397 0 0 0 2.395 2.394h6.699a2.397 2.397 0 0 0 2.394-2.395v-6.699a2.397 2.397 0 0 0-2.394-2.394zm.63 9.093a.63.63 0 0 1-.63.63h-6.7a.63.63 0 0 1-.63-.63v-6.699a.63.63 0 0 1 .63-.63h6.7a.63.63 0 0 1 .63.63v6.7z"
                />
                <path
                  d="M22.58 24.965h-6.7a2.418 2.418 0 0 1-2.414-2.415v-6.699a2.418 2.418 0 0 1 2.415-2.415h6.699a2.418 2.418 0 0 1 2.415 2.415v6.7a2.418 2.418 0 0 1-2.415 2.414zm-6.7-11.488a2.377 2.377 0 0 0-2.373 2.374v6.7a2.377 2.377 0 0 0 2.374 2.373h6.699a2.377 2.377 0 0 0 2.374-2.374v-6.699a2.377 2.377 0 0 0-2.374-2.374h-6.7zm6.7 9.724h-6.7a.651.651 0 0 1-.65-.65v-6.7c0-.359.292-.65.65-.65h6.7c.359 0 .65.291.65.65v6.7c0 .358-.291.65-.65.65zm-6.7-7.96a.61.61 0 0 0-.609.61v6.7c0 .335.274.609.61.609h6.699a.61.61 0 0 0 .61-.61v-6.699a.61.61 0 0 0-.61-.61h-6.7z"
                />
              </g>
            </g>
          </svg>

          <h5>{{$t('category')}}</h5>
        </router-link>
      </ul>
    </footer>
</template>

<script>
export default {
  name: "Footer",
   props: {
    dataLiveShow:{
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {
    footerTab(valuetype){
      if(valuetype === 'home'){
        clevertap.event.push("CLICKED_HOME_TAB")
      }else if(valuetype === 'shoppinggame'){
         clevertap.event.push("CLICKED_SHOPPING_TAB")
      }else if(valuetype === 'tvshop'){
         clevertap.event.push("CLICKED_LIVE_TAB")
      }else if(valuetype === 'orderhistory'){
         clevertap.event.push("CLICKED_ORDERHISTORY_TAB")
      }else if(valuetype === 'category'){
         clevertap.event.push("CLICKED_CATEGORY_TAB")
      }
    }
  }
};
</script>
    
<style scoped>
.badge1 .badge_text{
    top: -5px;
    right: -23px;
    padding: 3px 4px 0;
    /* border-radius: 0; */
    line-height: 1.2;
}
</style>